type PropsT = {
  className?: string
  strokeColor?: string
}

// Outline speech-bubble. Path/viewBox mirror
// veda:projects/unified-feedback-inbox/prototype/v69/index.html:1927's
// `.iec-ic svg` exactly — the "Nothing selected" thread-pane empty state's
// icon (docs `.ib-empty-convo`/`.iec-*`, index.html:951-957).
const ChatBubble = (props: PropsT) => {
  const { className, strokeColor = 'currentColor' } = props

  return (
    <svg
      className={className}
      width="30"
      height="30"
      viewBox="0 0 24 24"
      fill="none"
      stroke={strokeColor}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      data-testid="chat-bubble-icon"
    >
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  )
}

export default ChatBubble
